import { EntidadeBase } from 'hay-core-react';
class ClassificacaoNivelModel extends EntidadeBase {
  constructor() {
    super('classificacaonivel');
  }
}

export default new ClassificacaoNivelModel();
